
import { route_home, route_mypage, route_updateInfo } from "@/router";
import Vue from "vue";
import { UserTypes } from "@/types/abstract";
export default Vue.extend({
  async created() {
    if (this.$store.getters["auth/getUserType"] == UserTypes.Guest) {
      if (await this._checkGuestState()) {
        this.$router.push(route_home);
        return;
      }
    } else {
      if (await this._checkCastState()) {
        this.$router.push(route_mypage);
        return;
      }
    }
  },
  methods: {
    isGuest(): boolean {
      return this.$store.getters["auth/getUserType"] == UserTypes.Guest;
    },
    async checkState() {
      if (this.$store.getters["auth/getUserType"] == UserTypes.Guest) {
        this.checkGuestState();
      } else {
        this.checkCastState();
      }
    },
    async _checkCastState() {
      await this.$store.dispatch("userData/setCastData");
      if (await this.$store.dispatch("userData/isApproval")) {
        return true;
      }
      return false;
    },
    async checkCastState() {
      if (await this._checkCastState()) {
        this.$router.push(route_updateInfo);
        return;
      }
      alert("承認が完了していないため、もう少々お待ちください。");
    },
    async _checkGuestState() {
      await this.$store.dispatch("userData/setGuestData");
      if (await this.$store.dispatch("userData/isApproval")) {
        return true;
      }
      return false;
    },
    async checkGuestState() {
      if (await this._checkGuestState()) {
        this.$router.push(route_home);
        return;
      }
      alert("承認が完了していないため、もう少々お待ちください。");
    },
  },
});
